import { render, staticRenderFns } from "./TmSessionExtension.vue?vue&type=template&id=5e735219&scoped=true&"
import script from "./TmSessionExtension.vue?vue&type=script&lang=js&"
export * from "./TmSessionExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e735219",
  null
  
)

export default component.exports